import { render, staticRenderFns } from "./LogsMovimentacoes.vue?vue&type=template&id=23b1e3f9&scoped=true"
import script from "./LogsMovimentacoes.vue?vue&type=script&lang=js"
export * from "./LogsMovimentacoes.vue?vue&type=script&lang=js"
import style0 from "./LogsMovimentacoes.css?vue&type=style&index=0&id=23b1e3f9&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b1e3f9",
  null
  
)

export default component.exports